import { css } from "@emotion/react";
import { FC } from "react";

import { Info } from "@livechat/design-system-icons";
import { DesignToken, Icon, Text, Tooltip } from "@livechat/design-system-react-components";

import { trackInfoButtonHovered } from "helpers/analytics-reports";
import { withVar } from "themes/helpers";

const wrapperStyles = css`
  padding: 0 3px;
  margin-left: 3px;
  display: inline-block;
`;

interface IProps {
  children: React.ReactNode;
  chartTitle: string;
}

export const HelpTooltip: FC<IProps> = ({ children, chartTitle }) => {
  const handleTooltipOpen = (): void => trackInfoButtonHovered(chartTitle);

  return (
    <div css={wrapperStyles}>
      <Tooltip
        kind="invert"
        placement="right"
        onOpen={handleTooltipOpen}
        triggerRenderer={<Icon source={Info} size="small" customColor={withVar(DesignToken.ContentBasicPrimary)} />}
      >
        <Text>{children}</Text>
      </Tooltip>
    </div>
  );
};
